import _extends from "@babel/runtime/helpers/extends";
import { Box, FormField, Input, InputArea, Text } from '@wix/design-system';
import React, { useCallback } from 'react';
import { RuleListStatus } from '../../../types';
import { dataHooks } from '../../../utils/datahooks';
import { RuleFooter, RuleLayout } from '../../rule-layout';
import { InputCharCounter } from './input-char-counter';
import { InputFixerCompletedState } from './input-fixer-completed-state';
import { useInputFixer } from './use-input-fixer';
export const InputFixer = _ref => {
  let {
    ruleResult
  } = _ref;
  const {
    ruleFooterProps,
    value,
    tips,
    onChange,
    onBlur,
    inputStatus,
    placeholder,
    description,
    isEditMode,
    onEditClick,
    maxInputLength,
    isLargeInput,
    rows,
    suffix,
    autoFocus,
    showInputStatus,
    inputSuffix,
    inputPrefix
  } = useInputFixer(ruleResult);
  const handleBlur = useCallback(() => {
    onBlur();
  }, [onBlur]);
  const design = ruleResult.fixerProps.design;
  return ruleResult.status === RuleListStatus.passed && !isEditMode ? /*#__PURE__*/React.createElement(InputFixerCompletedState, {
    children: ruleResult.fixerProps.completedRuleContent.children,
    dataHook: dataHooks.completedTaskInputFixer(ruleResult.dataHook),
    description: ruleResult.fixerProps.completedRuleContent.description ?? description,
    ruleResult: ruleResult,
    onEditClick: onEditClick
  }) : /*#__PURE__*/React.createElement(RuleLayout, {
    description: description,
    design: design == null ? void 0 : design.ruleLayout
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: (design == null ? void 0 : design.formGap) ?? 'SP1'
  }, /*#__PURE__*/React.createElement(FormField, {
    dataHook: dataHooks.formFieldInputFixer(ruleResult.dataHook),
    label: ruleResult.fixerProps.fieldLabel,
    status: showInputStatus ? inputStatus == null ? void 0 : inputStatus.status : undefined,
    statusMessage: showInputStatus && inputStatus != null && inputStatus.statusMessage ? /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      skin: (inputStatus == null ? void 0 : inputStatus.status) === 'error' ? 'error' : undefined
    }, inputStatus.statusMessage) : undefined,
    suffix: /*#__PURE__*/React.createElement(Box, {
      align: "center",
      direction: "horizontal",
      gap: "SP1",
      verticalAlign: "middle"
    }, suffix, maxInputLength && maxInputLength > 0 && /*#__PURE__*/React.createElement(InputCharCounter, {
      count: value.length,
      max: maxInputLength,
      showDivider: suffix !== undefined
    }))
  }, isLargeInput ? /*#__PURE__*/React.createElement(InputArea, {
    autoFocus: autoFocus,
    dataHook: dataHooks.inputFieldInputFixer(ruleResult.dataHook),
    disabled: ruleFooterProps.submitButtonProps.showLoader,
    placeholder: placeholder,
    rows: rows,
    size: "small",
    value: value,
    onBlur: handleBlur,
    onChange: event => {
      onChange(event.target.value);
    }
  }) : /*#__PURE__*/React.createElement(Input, {
    autoFocus: autoFocus,
    dataHook: dataHooks.inputFieldInputFixer(ruleResult.dataHook),
    disabled: ruleFooterProps.submitButtonProps.showLoader,
    placeholder: placeholder,
    prefix: inputPrefix,
    size: "small",
    suffix: inputSuffix,
    value: value,
    onBlur: handleBlur,
    onChange: event => {
      onChange(event.target.value);
    }
  })), tips), /*#__PURE__*/React.createElement(RuleFooter, _extends({}, ruleFooterProps, {
    design: design == null ? void 0 : design.ruleFooter
  })));
};
//# sourceMappingURL=input-fixer.js.map